import { Component } from '@angular/core';

@Component({
  selector: 'app-deeplink',
  templateUrl: './Link.component.html',
})
export class LinkComponent {
  deeplink: any;
  constructor() {
   this.deeplink = window.location.href.split('?')[1];
  }
  openApp() {
    const appLink = "https://staging-hi.fpt.vn/app/?" + this.deeplink;
    const fallbackURL = "https://apps.apple.com/vn/app/hi-fpt/id1144417173?l=vi";

    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = appLink;

    document.body.appendChild(iframe);

    setTimeout(() => {
      document.body.removeChild(iframe);
      window.location.href = fallbackURL;
    }, 2000);
  }

}
